// trackEventEff :: String -> Effect Unit
export function trackEventEff (event) {
  return function () {
    Skubacz.tracking({tag: "TrackNamedEvent", event: event});
  };
}

export function getCurrencyEff () {
  return Skubacz.configuration.currency;
}

export function trackEventUniqueEff (eventKey) {
  return function (event) {
    return function () {
      var key = "tracking_" + eventKey;
      // Local storage needs to be used here, because some mobile clients will kill and reload a tab multiple times,
      // causing duplicate events
      if (localStorage.getItem(key) !== "true") {
        Skubacz.tracking({tag: "TrackNamedEvent", event: event});
        localStorage.setItem(key, "true");
      }
    };
  };
}

// trackUserTiming :: forall a. String -> String -> Effect a -> Effect a
/*
exports.trackUserTiming = function(category) {
  return function(variable) {
    return function(block) {
      if(window.performance) {
        return function() {
          var start = performance.now();
          var value = block();
          var end = performance.now();
          ga('restaumatic.send', 'timing', category, variable, end - start);
          return value;
        };
      } else {
        return block;
      }
    };
  };
};
*/
